export default __webpack_public_path__ + "static/metadata-privacy-e9c421c65b6576e4c704361215cbc5d1.svg";